import React, { Component } from 'react';
import UNLoginPage from '@components/UNLogin';
import UNLoginNew from '@components/LoginNewUN';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { loginCall, resendVerifyEmail } from '@reducers/login';
import { APP_CONFIG, ALLOWED_SERVICES } from '@constants';
import checkPermission from '@helpers/CheckPermission';
import EN from '@localization/EN';
import { getSubdomain } from '@helpers/Utility';

/*
**** State Description ****
* error: true/false based on it message will be shown
* message:  Message to show once any action is perfomed
*/
class UNLogin extends Component {
  components = {
    UNLoginPage,
    UNLoginNew
  };

  constructor(props) {
    super(props);
    this.state = {
      errmsg: false,
      errorDescription: '',
      showText: false,
      uname: '',
      disabledResendLink: false,
    };
  }

  componentDidMount= () => {
    if (window.location.hostname.includes('amp')) {
      window.location = 'https://warbler.kanari.ai/';
    }
    if (window.location.hostname.includes('app.kanari')) {
      window.location = 'https://app.fenek.ai/';
    }
    console.log('userData', window.localStorage.getItem('userData') && window.localStorage.getItem('userData') !== null);
    const userData = JSON.parse(window.localStorage.getItem('userData'));
    console.log('userData', userData);
    if (userData && userData.endUserDetails) {
      window.location = `${APP_CONFIG.BASE_URL}/Dashboard`;
    }
    const width = window.innerWidth;
    if (width < 767) {
      toast.info('The app is not yet optimised for mobile, please use Desktop for best experience', { position: toast.POSITION.BOTTOM_RIGHT, autoClose: false });
    }
    const accessTokenFromUrl = window.location.search;
    this.formatAndStoreAccesstokenFromUrl(accessTokenFromUrl);
  }

  formatAndStoreAccesstokenFromUrl = (urlParams) => {
    if (urlParams.indexOf('token') !== -1) {
      const splitParams = urlParams.split('=');
      const accessToken = decodeURIComponent(splitParams[1]);
      window.localStorage.setItem('azure_marketplace_token', accessToken);
      this.callAzureEndpointInNode();
    }
  };

  callAzureEndpointInNode = async () => {
    console.log(APP_CONFIG.AZURE_LANDING_PAGE_URL);
    const response = await fetch(APP_CONFIG.AZURE_LANDING_PAGE_URL);
    const res = await response.json();
    window.location = res.url;
  };

  /* Success of login function */
  successLogin = () => {
    const params = new URLSearchParams(document.location.search.substring(1));
    if (params && params.get('goback') === '1') {
      this.props.history.goBack();
    }
    if (typeof this.props.userData !== 'undefined') {
      // user login time for event
      window.localStorage.setItem('userLoginTime', new Date().getTime());
      window.localStorage.setItem('userData', JSON.stringify(this.props.userData));
      window.localStorage.setItem('access_token', this.props.userData.endUserDetails.access_token);
    }
    if (checkPermission(ALLOWED_SERVICES.INTERMIDIATE_SCREEN)) {
      if (window.localStorage.getItem('redirectUrl') === null) {
        window.localStorage.setItem('workspaceId', 1);
        this.props.history.replace(`${APP_CONFIG.BASE_URL}/core/`);
      } else {
        window.location = window.localStorage.getItem('redirectUrl');
        window.localStorage.removeItem('redirectUrl');
        window.localStorage.setItem('workspaceId', 1);
        window.localStorage.removeItem('redirectUrl');
      }
    } else if (window.localStorage.getItem('redirectUrl') === null) {
      window.location = `${APP_CONFIG.BASE_URL}/Dashboard`;
    } else {
      window.location = window.localStorage.getItem('redirectUrl');
      window.localStorage.setItem('workspaceId', 1);
      window.localStorage.removeItem('redirectUrl');
    }
  };

  /* Failure of login function */
  failureLogin = (response) => {
    console.log('response of failed ', response);
    if (response && response.error_description && response.error_description.includes('Bad credentials')) {
      this.setState({
        errmsg: true,
        errorDescription: EN.LoginInactiveUserErrorMsg,
      });
    } else {
      this.setState({
        errmsg: this.props.errmsg,
        errorDescription: EN.LoginErrorMsg
      });
    }
    toast.error((this.state.errorDescription), { position: toast.POSITION.BOTTOM_RIGHT });
  };

  // Reset fail msg//

  resetMsg =() => {
    this.setState({
      errmsg: false,
      errorDescription: '',
      disabledResendLink: false,
    });
  }

  resetVerificationFlag =() => {
    this.setState({
      disabledResendLink: false,
    });
  }

  resendVerify =() => {
    const { uname } = this.state;
    const subdomain = getSubdomain();
    const data = {
      email: uname,
      subDomain: subdomain
    };
    this.props.resendVerifyEmail(data).then(() => {
      toast.success(('Verification email sent!'), { position: toast.POSITION.BOTTOM_RIGHT });

      this.resetMsg();
      this.setState({
        disabledResendLink: true,
      });
    })
      .catch(() => {
        toast.error(('Verification failed!'), { position: toast.POSITION.BOTTOM_RIGHT });
      });
  }


  submitlogin = (values) => {
    const userName = values.userName;
    const password = values.password;
    // console.log(userName);
    if (userName !== '' && password !== '') {
      const Values = {
        username: userName,
        password
      };
      this.props.loginCall(Values).then(this.successLogin).catch((response) => { this.failureLogin(response); });
      this.setState({
        uname: userName,
        disabledResendLink: false,
      });
    } else {
      this.setState({
        errmsg: true,
        errorDescription: EN.LoginDataEmpty
      });
    }
  }

  ontoggleClickLock = () => {
    let showText = true;
    if (this.state.showText) {
      showText = false;
    } else {
      showText = true;
    }
    this.setState({ showText });
  }

  render() {
    const subdomain = getSubdomain();
    const Login = (subdomain === EN.AMP_VALUE || subdomain === EN.STAGEUN_VALUE) ? UNLoginNew : UNLoginNew;
    return (
      <>
        <Login
          handleSubmit={this.submitlogin}
          errmsg={this.state.errmsg}
          errorDescription={this.state.errorDescription}
          ontoggleClickLock={this.ontoggleClickLock}
          showText={this.state.showText}
          resetMsg={this.resetMsg}
          resendVerify={this.resendVerify}
          disabledResendLink={this.state.disabledResendLink}
          resetVerificationFlag={this.resetVerificationFlag}
          loginLoading={this.props.loginLoading}
        />
      </>
    );
  }
}
const mapStateToProps = state => ({
  errmsg: state.login.error,
  errorDesc: state.login.errorDesc,
  userData: state.login.data,
  loginLoading: state.login.loginLoading,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  loginCall,
  resendVerifyEmail
}, dispatch);

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(UNLogin)
);
